module.exports = __webpack_public_path__ + "5122f3b240a86bdadcc5006a49788e2d.svg";